import exceptionReporter from '@aytm/lib/common/exception-reporter'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

/*
 *  compare values
 */
export function arrayValuesEqual(next, prev) {
  if (next != prev && Array.isArray(next) && Array.isArray(prev)) {
    if (next.length != prev.length) {
      return false
    } else {
      for (const [i, element] of prev.entries()) {
        if (element != next[i]) return false
      }
      return true
    }
  } else {
    return next == prev
  }
}

export function objectValuesEqual(next, prev) {
  if (next != prev && null != next && 'object' == typeof next && null != prev && 'object' == typeof prev) {
    const nextKeys = Object.keys(next)
    const prevKeys = Object.keys(prev)
    if (nextKeys.length == prevKeys.length) {
      for (const nextKey of nextKeys) {
        if (next[nextKey] != prev[nextKey]) {
          return false
        }
      }
      return true
    } else {
      return false
    }
  } else {
    return next == prev
  }
}

/*
 * ManagedRenderComponent
 */

export function compareAllProps(nextProps = {}, prevProps = {}) {
  const propTypes = this.constructor.propTypes || {}
  const propTypeKeys = Object.keys(propTypes)

  for (const propTypeKey of propTypeKeys) {
    if (!arrayValuesEqual(nextProps[propTypeKey], prevProps[propTypeKey])) {
      return true
    }
  }
  return false
}

export function comparePureProps(nextProps = {}, prevProps = {}) {
  const nextPropsKeys = Object.keys(nextProps)
  const prevPropsKeys = Object.keys(prevProps)
  if (nextPropsKeys.length != prevPropsKeys.length) {
    return true
  } else {
    for (const nextPropsKey of nextPropsKeys) {
      if (nextProps[nextPropsKey] != prevProps[nextPropsKey]) {
        return true
      }
    }
    return false
  }
}

export function comparePureData(nextProps = {}, prevProps = {}) {
  const nextPropsKeys = Object.keys(nextProps)
  const prevPropsKeys = Object.keys(prevProps)
  for (const nextPropsKey of nextPropsKeys) {
    if ('function' == typeof nextProps[nextPropsKey] && 'function' == typeof prevProps[nextPropsKey]) {
      continue
    }
    if (nextProps[nextPropsKey] != prevProps[nextPropsKey]) {
      return true
    }
  }
  for (const prevPropsKey of prevPropsKeys) {
    if ('function' == typeof nextProps[prevPropsKey] && 'function' == typeof prevProps[prevPropsKey]) {
      continue
    }
    if (nextProps[prevPropsKey] != prevProps[prevPropsKey]) {
      return true
    }
  }
  return false
}

export default class ManagedRenderComponent extends Component {
  static propTypes = {
    saveRef: PropTypes.func
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (null == this.shouldComponentUpdateOnProps) {
      const updateOnProps = this.constructor.updateOnProps || 'pure'
      this.shouldComponentUpdateOnProps =
        'all' == updateOnProps
          ? compareAllProps.bind(this)
          : 'pure' == updateOnProps
          ? comparePureProps.bind(this)
          : 'pure data' == updateOnProps
          ? comparePureData.bind(this)
          : Array.isArray(updateOnProps)
          ? function (nextProps = {}, prevProps = {}) {
              for (const updateOnProp of updateOnProps) {
                if (!arrayValuesEqual(nextProps[updateOnProp], prevProps[updateOnProp])) {
                  return true
                }
              }
              return false
            }
          : 'function' == typeof updateOnProps
          ? updateOnProps
          : true === updateOnProps
          ? function () {
              return true
            }
          : false === updateOnProps
          ? function () {
              return false
            }
          : function () {
              return true
            }
    }

    if (null == this.shouldComponentUpdateOnState) {
      this.shouldComponentUpdateOnState = function (nextState, prevState) {
        const nextStateKeys = null == nextState ? [] : Object.keys(nextState)
        const prevStateKeys = null == prevState ? [] : Object.keys(prevState)
        if (nextStateKeys.length != prevStateKeys.length) {
          return true
        } else if (0 == nextStateKeys.length) {
          return false
        } else {
          for (const nextStateKey of nextStateKeys) {
            if (nextState[nextStateKey] != prevState[nextStateKey]) {
              return true
            }
          }
          return false
        }
      }
    }

    return (
      this.shouldComponentUpdateOnState(nextState, this.state) ||
      this.shouldComponentUpdateOnProps(nextProps, this.props)
    )
  }

  UNSAFE_componentWillMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  // eslint-disable-next-line no-dupe-class-members
  saveRef(name, { unwrap = false } = {}) {
    return (
      this[`saveRef${name}`] ||
      (this[`saveRef${name}`] = function (_element) {
        let element = _element
        if (unwrap) {
          while (element && element.refWrappedComponent) {
            element = element.refWrappedComponent
          }
        }
        this[`ref${name}`] = element
        if ('function' == typeof this.props.saveRef) {
          this.props.saveRef(name, element)
        }
      }.bind(this))
    )
  }
  // eslint-disable-next-line no-dupe-class-members
  saveRef = this.saveRef.bind(this)

  // eslint-disable-next-line no-dupe-class-members
  setState(...args) {
    if (this.mounted) {
      super.setState.apply(this, args)
    }
  }
  // eslint-disable-next-line no-dupe-class-members
  setState = this.setState.bind(this)

  componentDidCatch(error, info) {
    exceptionReporter(error, 'common', info)
    this.renderBeforeError = this.render
    this.render =
      'function' == typeof this.renderError
        ? this.renderError
        : function () {
            return <div style={{ background: 'red', fontSize: '12px', lineHeight: '12px', color: 'white' }}>ERR</div>
          }
    this.forceUpdate()
  }
}
